import React from "react";
import { Link } from "react-router-dom";
import PageShell from "../PageShell";
import { Reveal } from "../UIKit";

const problems = [
  { title: "Manual plate entry, all day", body: "Guards retype every cab and delivery plate by hand — hundreds of times a shift, with just as many chances for error." },
  { title: "One-at-a-time approvals", body: "Residents open the app and approve entries one by one, instead of trusted vehicles being recognised automatically." },
  { title: "Your data, someone else's server", body: "Visitor and payment data sits on a shared corporate cloud, not your society's own infrastructure." },
  { title: "Maintenance is reactive", body: "Lifts and pumps get fixed after they break — turning a maintenance schedule into an emergency bill." },
];

export default function WhyPage({ onAuthClick }) {
  return (
    <PageShell
      onAuthClick={onAuthClick}
      eyebrow="Why Bellboy exists"
      title="Today's society apps stop at digitising the visitor log."
      lede="The manual work underneath it — approvals, follow-ups, fixes — is still all on your guards and committee."
      sceneMode="friction"
      seoTitle="Why Bellboy — Security & Society Management App"
      seoDescription="Why housing societies need more than a digitised visitor log, and how Bellboy removes the manual work underneath it."
    >
      <section className="page-section">
        <div className="problem-grid" style={{ maxWidth: "100%" }}>
          {problems.map((p, i) => (
            <Reveal
              key={p.title}
              delay={i * 90}
              className="problem-row"
              style={{ flexDirection: "column", alignItems: "flex-start", gap: 8 }}
            >
              <span className="problem-index">{String(i + 1).padStart(2, "0")}</span>
              <strong>{p.title}</strong>
              <span style={{ fontWeight: 600, opacity: 0.85 }}>{p.body}</span>
            </Reveal>
          ))}
        </div>
        <Reveal delay={120}>
          <Link to="/product" className="section-btn">See how Bellboy fixes this →</Link>
        </Reveal>
      </section>
    </PageShell>
  );
}
